export const levelCheck = {
  title: '레벨 체크',
  subtitle: '현재 언어 레벨을 확인하세요',
  
  // Language Selection
  selectLanguage: '학습 언어 선택',
  selectLanguagePlaceholder: '언어를 선택하세요',
  japanese: '日本語',
  korean: '한국어',
  english: 'English',
  
  // Email Input
  emailLabel: '이메일 주소',
  emailPlaceholder: 'your.email@example.com',
  emailDescription: '테스트 결과를 보내드립니다',
  
  // Buttons
  startTest: '테스트 시작',
  nextQuestion: '다음',
  previousQuestion: '이전',
  submitTest: '테스트 제출',
  
  // Test Progress
  question: '문제',
  of: '/',
  
  // Results
  resultsTitle: '테스트 결과',
  yourLevel: '당신의 레벨',
  score: '점수',
  passed: '합격',
  failed: '불합격',
  passThreshold: '합격 기준: 85% 이상',
  
  // Messages
  selectLanguageFirst: '언어를 선택해주세요',
  enterEmail: '이메일 주소를 입력해주세요',
  testSubmitted: '테스트가 제출되었습니다. 결과를 이메일로 보내드립니다.',
  errorSubmitting: '오류가 발생했습니다. 다시 시도해주세요.',

  // ── 레벨 체크 페이지 전체 (level-check/page.tsx) ──
  // 유효성 검사·알림
  enterName: '이름을 입력해주세요',
  invalidEmail: '이메일 형식이 올바르지 않습니다',
  selectLearningLanguage: '학습 중인 언어를 선택해주세요',
  saveFailed: '결과 저장에 실패했습니다. 다시 시도해주세요.',

  // 언어명(학습 언어 표시)
  langEnglish: '영어',
  langJapanese: '일본어',
  langKorean: '한국어',

  // 인트로 화면
  pageTitle: '언어 레벨 체크',
  pageSubtitle: '레벨 체크를 시작하기 전에 정보를 입력해주세요',
  namePlaceholder: '이름',
  emailInputPlaceholder: '이메일 주소',
  selectLearningLanguageLabel: '학습 중인 언어를 선택해주세요',
  testStructure: '테스트 구성:',
  levelAJa: '레벨 A: 12문제(어휘 4문제 + 능력 8문제)',
  levelAOther: '레벨 A: 8-10문제(초급)',
  levelB1Ja: '레벨 B1: 12문제(어휘 4문제 + 능력 8문제)',
  levelB1Other: '레벨 B1: 8-10문제(중급)',
  levelB2Ja: '레벨 B2: 12문제(어휘 4문제 + 능력 8문제)',
  levelB2Other: '레벨 B2: 8-10문제(중상급)',
  levelCJa: '레벨 C: 12문제(어휘 4문제 + 능력 8문제)',
  levelCOther: '레벨 C: 8-10문제(고급)',
  scoringNote: '각 레벨에서 85% 이상의 점수로 다음 레벨로 진행합니다',
  scoringNoteJa: '각 레벨에서 85% 이상의 점수로 다음 레벨로 진행합니다. 일본어 버전: 어휘 문제 20점 + 능력 문제 80점 = 총 100점',
  startCheck: '레벨 체크 시작',

  // 결과 화면
  testComplete: '테스트 완료!',
  learningLanguageLabel: '학습 언어: ',
  yourLevelLabel: '당신의 레벨: ',
  levelValue: '레벨 {{level}}',
  thankYouBody: '레벨 체크를 완료해 주셔서 감사합니다, {{name}}님! 결과를 검토하고 {{email}}로 다음 단계를 안내해 드리겠습니다.',
  returnHome: '홈으로 돌아가기',

  // 퀴즈 화면
  levelAssessment: '언어 레벨 평가',
  questionProgress: '문제 {{current}} / {{total}}',
  previous: '이전',
  next: '다음',
  submitting: '제출 중...',
  submitLevel: '레벨 제출'
};
